module.exports = __webpack_public_path__ + "img/screen-bottom.73d63860.png";